// extracted by mini-css-extract-plugin
export var alignCenter = "_95-d";
export var bannerShown = "_95-6";
export var buttonContent = "_95-0";
export var cardList = "_95-1";
export var centerContent = "_95-2";
export var chevron = "_95-3";
export var closePanelButton = "_95-k";
export var conversationContextContainer = "_95-l";
export var conversationDetailContainer = "_95-4";
export var detailWrapper = "_95-7";
export var dropdownButton = "_95-e";
export var dropdownTitle = "_95-9";
export var fullHeight = "_95-5";
export var hidden = "_95-a";
export var icon = "_95-b";
export var mergeSuggestionWrapper = "_95-m";
export var panel = "_95-i";
export var portalButtonsWrapper = "_95-c";
export var right = "_95-j";
export var tableSummaryContainer = "_95-8";
export var tableSummaryHeader = "_95-g";
export var threeDotsButton = "_95-f";
export var wide = "_95-h";